import { render, staticRenderFns } from "./MarcaRoute.vue?vue&type=template&id=188be9e4"
import script from "./MarcaRoute.vue?vue&type=script&lang=js"
export * from "./MarcaRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports